import React, { useState, useEffect } from "react";
import { message } from "antd";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PrimaryProgress from "../../../containers/progress/primary_progress";
import { findSellerOrdersGroupDateEvent } from '../../../_events/sellers/find_orders.event';
import { Button, Divider } from "@mui/material";
import InfoOrderModal from "../orders_history/info_order_modal";
import { MONTHS } from "../../../_utils/month_labels";

const ID_PANEL = 'panel_pocket_balance';


const SellerOrdersGroupDate = (props) => {

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);

    const findData = (y, m) => {
        setLoading(true);
        findSellerOrdersGroupDateEvent(y, m)
        .then(data => {
            setData(data.list);
            setLoading(false);
        })
        .catch(err => {
            message.error(err.message);
            setLoading(false);
        });
    };

    useEffect(() => {
        findData(year, month);
    }, [year, month]);   

    if(loading){
        return(
            <PrimaryProgress />
        );
    }
    else{
        return(
            <div style={{height:450, width: '100%', overflow: 'auto' }}>
                <Button variant="contained" size="small" onClick={() => props.goBack()}>Listado general</Button>
                <hr />
                <select 
                    value={month}
                    onChange={(e) => {
                        setMonth(e.target.value);
                    }}
                >
                    {
                        MONTHS.slice(1, MONTHS.length).map((m, key) => (
                            <option key={`months_${key}`} value={key + 1}>
                                {m}
                            </option>
                        ))
                    }
                </select>
                {
                    data.map((d, key) => (
                        <Accordion key={`${ID_PANEL}${key}`} >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`${ID_PANEL}${key}bh-content`}
                                id={`${ID_PANEL}${key}bh-header`}
                                >
                                <Typography sx={{ width: '50%', flexShrink: 0 }}>
                                    {d.key}
                                </Typography>                               
                            </AccordionSummary>
                            <AccordionDetails>
                                <div style={{width: '100%'}}>
                                    <AccordionInfo data={d.data} />
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    ))
                }
            </div>
        );
    }
}

const AccordionInfo = (props) => {
    return(
        <div>
        {
            props.data.length === 0 ? (
             <>No hay datos</>
            ) : (
            <div style={{width: '100%'}}>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                    <div style={{width: '30%', fontSize:'10px', fontWeight: 'bold'}}>Fecha</div>
                    <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Número</div>
                    <div style={{width: '30%', fontSize:'10px', fontWeight: 'bold'}}>Cliente</div>
                    <div style={{width: '20%', fontSize:'10px', fontWeight: 'bold'}}>Detalle</div>
                </div>
                <div style={{width: '100%'}}>
                {
                    props.data.map((d, key) => {
                        return(
                            <div key={key} style={{width: '100%'}}>
                                <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                    <div style={{width: '30%', fontSize:'10px'}}>{d.date_created}</div>
                                    <div style={{width: '20%', fontSize:'10px'}}>{d.id}</div>
                                    <div style={{width: '30%', fontSize:'10px'}}>{d.ordersDetail[0].productPrice.client.name}</div>
                                    <div style={{width: '20%', fontSize:'10px'}}><InfoOrderModal data={d.ordersDetail} order={d} /></div>
                                </div>
                                <Divider />
                            </div>
                        )
                    })
                }
                </div>
            </div>
            )
         }
        </div>
    );
}

export default SellerOrdersGroupDate;